<template>
  <svg
    :class="customClass"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
</template>

<script>
export default {
  name: "EyeIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
  },
};
</script>
